// Use a separate rendering context so tag editing keeps the Asset Identity name.
export function getAnnotationCaption(annotation: { Text: string; Caption?: string | null }): string {
    return annotation.Caption?.trim() ? annotation.Caption : annotation.Text;
}
